<template lang="pug">
  .home.text-center
    RoleSelect
    img(alt="Vue logo" src="@/assets/logo.png" style="max-height:100px;")
    HelloWorld(msg="Welcome to Certainty" submsg="This is an example page that the user will see when logged in.")
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import RoleSelect from '@/components/roleSelect.vue';

export default {
  name: 'Home',
  components: {
    HelloWorld,
    RoleSelect
  }
}
</script>
